import React from "react";
import { ChartDonutThreshold, ChartDonutUtilization } from '@patternfly/react-charts/victory';
import { VictoryLabel } from 'victory';
import { formatBytes } from 'shared/utils/formatBytes'

// Funkcja dobiera kolor tekstu w zależności od motywu
const getChartTextColor = () => {
  return document.documentElement.classList.contains("pf-v6-theme-dark")
    ? "#f5f5f5"
    : "#151515";
};

const ChartUtilSmallSubtitle = ({ 
  diskUsagePercent,
  diskUsageBytes,
  diskSize,
  loading
}) => {

  const textColor = getChartTextColor();

  const dataThreshold = [
    { x: "Warning at 60%", y: 60 },
    { x: "Danger at 90%", y: 90 }
  ];

  const dataUtil = { x: "Użycie dysku", y: diskUsagePercent };

  const legendData = [
    { 
      name: loading 
        ? "Ładowanie..." 
        : `Użycie dysku: ${diskUsagePercent}%`, 
      labels: { fill: textColor } 
    },
    { name: "Próg ostrzeżenia: 60%", labels: { fill: textColor } },
    { name: "Próg krytyczny: 90%", labels: { fill: textColor } }
  ];

  return (
    <>
      <div style={{ height: "105px", width: "250px" }}>
        <ChartDonutThreshold
          ariaDesc="Storage capacity"
          constrainToVisibleArea
          data={dataThreshold}
          height={150}
          width={320}
          padding={{ bottom: 25, left: 0, right: 200, top: 10 }}
          subTitlePosition="bottom"
        >
          <ChartDonutUtilization
            data={dataUtil}
            labels={({ datum }) =>
              datum.x ? `${datum.x}: ${datum.y}%` : null
            }
            legendData={legendData}
            legendOrientation="vertical"
            subTitle={
              loading 
                ? "Ładowanie..." 
                : `${formatBytes(diskUsageBytes)} / ${formatBytes(diskSize)}`
            }
            title={loading ? "0%" : `${diskUsagePercent}%`}
            thresholds={[{ value: 60 }, { value: 90 }]}
            titleComponent={
              <VictoryLabel
                style={[
                  { fill: textColor, fontSize: 18 },
                  { fill: textColor, fontSize: 12 }
                ]}
              />
            }
          />
        </ChartDonutThreshold>
      </div>
    </>
  );
};

export default ChartUtilSmallSubtitle;